<template>
  <div>
    <collapse v-if="distributor && campaignSelected" :active-index="0">
      <collapse-item>
        <h3 slot="title" class="mb-0">Información</h3>

        <div>
          <div class="row">
            <div class="col-sm-6">
              <p class="h5 mb-0">Campaña</p>
              <p>{{ campaignSelected.name }}</p>
            </div>
            <div class="col-sm-6">
              <p class="h5 mb-0">Distribuidor</p>
              <p>{{ distributor.name }}</p>
            </div>
          </div>
        </div>
      </collapse-item>
    </collapse>

    <collapse v-if="totals">
      <collapse-item body-classes="p-0 m-0">
        <template slot="title">
          <h3 class="mb-0">
            <span>Resumen por Variedad</span>
          </h3>
        </template>

        <div class="table-responsive">
          <el-table :data="varieties" header-row-class-name="thead-light" row-key="id">
            <el-table-column label="Variedad" min-width="120px" prop="varietyName">
              <template #default="{ row }">
                <span>{{ row.name }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Recibidas" min-width="120px" prop="received" class="classRowBackgroundColor10">
              <template #default="{ row }">
                <span class="marginLeft10">{{ row.received }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Ajustes" min-width="120px" prop="adjusts">
              <template #default="{ row }">
                <span class="marginLeft10">{{ row.adjusts }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Pedidos" min-width="120px" prop="orders">
              <template #default="{ row }">
                <span class="marginLeft10">{{ row.orders }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Transf" min-width="120px" prop="transfers">
              <template #default="{ row }">
                <span class="marginLeft10">{{ row.transfers }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Dev.C.Central" min-width="120px" prop="devolutions">
              <template #default="{ row }">
                <span class="marginLeft10">{{ row.devolutions }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Stock" min-width="120px" prop="stock">
              <template #default="{ row }">
                <span class="marginLeft10">{{ row.stock }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </collapse-item>
    </collapse>

    <card v-if="isDataLoaded" body-classes="px-0 pb-1" class="table-responsive">
      <el-table
        v-if="rows.length"
        :data="rows"
        :summary-method="getSummaries"
        show-summary
        header-row-class-name="thead-light"
        row-key="id"
        :row-class-name="getRowClass"
      >
        <el-table-column label="Fecha" min-width="120px" prop="date">
          <template #default="{ row }">
            <span>{{ row.date | date('DD/MM/YY') }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Comp." min-width="100px" prop="type">
          <template #default="{ row }">
            <span class="h5">{{ row.type }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Tipo." min-width="100px" prop="type">
          <template #default="{ row }">
            <span v-if="row.deliveryNoteType">{{ row.deliveryNoteType.substring(0, 6) }}</span>
            <span v-else> - </span>
          </template>
        </el-table-column>

        <el-table-column label="Nº" min-width="120px" prop="code">
          <template #default="{ row }">
            <span>{{ row.code }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Razon Social" min-width="150px" prop="producer">
          <template #default="{ row }">
            <span v-if="row.producerName">{{ row.producerName }}</span>
            <span v-else class="d-block text-center">-</span>
          </template>
        </el-table-column>

        <el-table-column label="Descripcion" min-width="150px" prop="article">
          <template #default="{ row }">
            <span>{{ row.article }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Ingreso" min-width="130px" prop="entryStock">
          <template #default="{ row }">
            <span v-if="row.entryStock">{{ row.entryStock }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>

        <el-table-column label="Salida" min-width="130px" prop="outputStock">
          <template #default="{ row }">
            <span v-if="row.outputStock">{{ row.outputStock }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>

        <el-table-column label="Stock" min-width="130px">
          <template #default="{ row }">
            <span>{{ row.runningStock }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Dep. Salida" min-width="150px" prop="distributorFrom">
          <template #default="{ row }">
            <span v-if="row.distributorFromName">{{ row.distributorFromName }}</span>
            <span v-else class="font-italic">{{ MAIN_DEPOSIT_LABEL }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Dep. Entrada" min-width="160px" prop="distributorTo">
          <template #default="{ row }">
            <span v-if="row.distributorToName">{{ row.distributorToName }}</span>
            <span v-else class="font-italic">{{ MAIN_DEPOSIT_LABEL }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Autor" min-width="150px" prop="author">
          <template #default="{ row }">
            <span v-if="row.userName">{{ row.userName }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div v-else slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <p class="card-category">No hay datos para mostrar.</p>
      </div>
    </card>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui';

import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

import { TYPE_ORDER, TYPE_DELIVERY_NOTE, MAIN_DEPOSIT_LABEL } from '@/util/constants/deliveryNotes';
import CurrentCampaignMixin from '@/mixins/currentCampaignMixin';
import { withRunningStock } from '@/util/stockMovements';

import '@/assets/css/styles.css';

let lastArticleIdForClassRow;
let lastArticleId;
let whiteColor = true;
let classRow = 'classRowBackgroundColorWhite';

export default {
  name: 'StockByDistributor',
  components: {
    Collapse,
    CollapseItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  mixins: [CurrentCampaignMixin],

  props: {
    distributorId: {
      required: true,
      type: Number,
    },
  },

  data() {
    return {
      distributor: null,
      campaignSelected: null,
      isDataLoaded: false,
      rows: [],
      varieties: [],
      totals: null,

      MAIN_DEPOSIT_LABEL,
      TYPE_ORDER,
      TYPE_DELIVERY_NOTE,
    };
  },

  watch: {
    distributorId: {
      immediate: true,
      async handler() {
        await this.getRows();
        await this.getTotals();
        await this.fetchDistributor();
        await this.fetchCampaign();
      },
    },
  },

  methods: {
    getSummaries({ columns }) {
      const summary = [];

      columns.forEach((col, index) => {
        if (col.property === 'date') {
          summary[index] = 'Stocks';
        } else if (col.property === 'entryStock') {
          summary[index] = this.totals.entryStock;
        } else if (col.property === 'outputStock') {
          summary[index] = this.totals.outputStock;
        } else if (col.property === 'author') {
          summary[index] = `Total: ${this.totals.totalStock}`;
        }
      });

      return summary;
    },

    getRows() {
      this.$services
        .resource('stocks')
        .byDistributor(this.campaign, this.distributorId)
        .then((res) => {
          this.rows = withRunningStock(res.data);
        });
    },

    getTotals() {
      this.$services
        .resource('stocks')
        .totalsByDistributor(this.campaign, this.distributorId)
        .then((res) => {
          this.totals = res.data;
        });
      this.$services
        .resource('stocks')
        .varietiesSummary(this.campaign, this.distributorId)
        .then((res) => {
          this.varieties = res.data;
        });
    },

    fetchDistributor() {
      this.$services
        .resource('distributors')
        .show(this.distributorId)
        .then((res) => res.data.data)
        .then((distributor) => {
          this.distributor = distributor;
        });
    },

    getRowClass(row) {
      if (lastArticleId !== row.row.article_id) {
        lastArticleId = row.row.article_id;
        classRow =
          classRow === 'classRowBackgroundColorWhite' ? 'classRowBackgroundColorCake' : 'classRowBackgroundColorWhite';
      }
      return classRow;
    },

    fetchCampaign() {
      this.$services
        .resource('campaigns')
        .show(this.campaign)
        .then((res) => res.data.data)
        .then((campaign) => {
          this.campaignSelected = campaign;
          this.isDataLoaded = true;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .el-table__footer-wrapper .el-table__cell .cell {
  font-weight: 600;
  font-size: 16px;
  padding-left: 0;
}
</style>
